import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Buildings } from "@phosphor-icons/react";

export function useCompanyLabel() {
  const [label, setLabel] = useState("");
  useEffect(() => { api.get("/company/label").then((r) => setLabel(r.data.label)).catch(() => {}); }, []);
  return label;
}

export function CompanyInfoBanner() {
  const { user } = useAuth();
  if (!user || !["company", "autonomo"].includes(user.role)) return null;
  const isAuto = user.role === "autonomo";
  if (isAuto ? user.contractor_name : user.company_name && user.cnpj) return null;
  const base = user.role === "company" ? "/empresa" : "/autonomo";
  return (
    <div data-testid="company-info-banner" className="print:hidden flex flex-wrap items-center justify-between gap-3 rounded-lg border-2 border-amber-300 bg-amber-50 p-3 text-sm">
      <div className="flex items-start gap-2 text-amber-900 min-w-0 flex-1">
        <Buildings size={18} weight="duotone" className="shrink-0 mt-0.5" />
        {isAuto
          ? <p>Informe a <b>empresa para quem você presta serviço</b> (e o CNPJ dela) para sair no acerto e nos relatórios.</p>
          : <p>Complete o <b>nome da empresa</b> e o <b>CNPJ</b> para saírem no acerto e nos relatórios.</p>}
      </div>
      <Link to={`${base}/perfil`} data-testid="btn-complete-company-info" className="px-3 py-1.5 rounded-md bg-amber-600 hover:bg-amber-700 text-white font-semibold">Completar agora</Link>
    </div>
  );
}

export async function loadImageDataUrl(fileId) {
  try {
    const r = await api.get(`/files/${fileId}`, { responseType: "blob" });
    const url = await new Promise((res) => { const fr = new FileReader(); fr.onload = () => res(fr.result); fr.readAsDataURL(r.data); });
    const ratio = await new Promise((res) => { const im = new Image(); im.onload = () => res(im.width / im.height || 1); im.onerror = () => res(1); im.src = url; });
    const format = /png/i.test(r.data.type) ? "PNG" : "JPEG";
    return { url, ratio, format };
  } catch { return null; }
}

export function useCompanyLogo() {
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    api.get("/company/label").then((r) => r.data.logo_file_id && loadImageDataUrl(r.data.logo_file_id).then(setLogo)).catch(() => {});
  }, []);
  return logo;
}
